import FilterLegend from './FilterLegend';

const els = document.querySelectorAll('.filter-legend');

for (let el of els) {
    new FilterLegend(el);
}
